import {LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';

import {MarkdownModule} from 'ngx-markdown';
import {CoreModule} from '@core/core.module';
import {TemplateModule} from '@lhacksrt/template.module';
import {TemplateConfigModule} from '@lhacksrt/services/config';
import {appConfig} from '@core/config/app.config';
import {LayoutModule} from './layout/layout.module';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {ServicesModule} from '@core/services/services.module';
import {MAT_DATE_LOCALE, provideNativeDateAdapter} from '@angular/material/core';
import {ErrorManagerComponent} from "@lhacksrt/services/error/error-manager.component";
import {ErrorManagerInterceptor} from "@lhacksrt/services/error/error-manager.interceptor";
import {registerLocaleData} from "@angular/common";
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeFr, 'fr');

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    TemplateModule,
    TemplateConfigModule.forRoot(appConfig),
    CoreModule,
    LayoutModule,
    MarkdownModule.forRoot({}),
    ServicesModule,
    ErrorManagerComponent
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideNativeDateAdapter(),
    {provide: MAT_DATE_LOCALE, useValue: 'fr-FR'},
    {provide: LOCALE_ID, useValue: 'fr'},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorManagerInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
